export default __webpack_public_path__ + "static/media/Frame2.08a472e9.svg";